import type {
  IMediaLibDialogItem,
  TElement,
} from "@editor/modules/media-lib/types";
import {
  type ComponentType,
  type ReactNode,
  createContext,
  useContext,
} from "react";
import type { IStockVideo } from "../types";

type StockVideosViewType = "dialog" | "panel";

interface StockVideosCtxValue {
  view?: StockVideosViewType;
  isMultiSelect?: boolean;
  selectedItems?: IMediaLibDialogItem[];
  onSelect?: (item: IStockVideo) => void;
  elementWrapper?: ComponentType<{ children: ReactNode; element: TElement }>;
}

const StockVideosCtx = createContext<StockVideosCtxValue | undefined>(
  undefined,
);

export const StockVideosProvider = ({
  children,
  view = "panel",
  isMultiSelect,
  onSelect,
  elementWrapper,
  selectedItems,
}: {
  children: ReactNode;
  view?: StockVideosViewType;
  isMultiSelect?: boolean;
  selectedItems?: IMediaLibDialogItem[];
  elementWrapper?: ComponentType<{ children: ReactNode; element: TElement }>;
  onSelect?: (item: IStockVideo) => void;
}) => {
  return (
    <StockVideosCtx.Provider
      value={{
        view,
        isMultiSelect,
        onSelect,
        selectedItems,
        elementWrapper,
      }}
    >
      {children}
    </StockVideosCtx.Provider>
  );
};

export const useStockVideosCtx = () => {
  const ctx = useContext(StockVideosCtx);
  if (!ctx) {
    throw new Error(
      "useStockImagesCtx must be used within a StockImagesProvider",
    );
  }
  return ctx;
};
